export const environment = {
    production: false,
    apiUrl: 'https://api.travel.dev.heirsinsurancegroup.com/',
    cacUrl: 'https://metamapapi-staging.heirsinsurancegroup.com/api/v1/',
    METAMAP_KEY: '543889cea306744557f0d4b8e8ffc778fc3dd5ee5acd46130215887dcfd90e60',
};
